import { atom } from 'jotai'
import { type PropsAlert } from 'src/components/atoms/alert/Alert'
import { UserMeAtom } from '@/types/apps/userMe.type'

type AlertAtom = {
  title?: string
  content?: string
  subTitle?: string
  variant: 'danger' | 'success'
  size?: 'small' | 'large'
  color?: PropsAlert['color']
  icon?: 'ic:baseline-check' | 'ic:baseline-do-disturb'
  pathname?: string
  open?: boolean
  actionType?: 'add' | 'edit' | 'delete' | undefined
}

export const alertAtom = atom<AlertAtom>({
  title: '',
  content: '',
  variant: 'success',
  size: 'small',
  color: 'success',
  icon: 'ic:baseline-check',
  pathname: '',
  open: false,
  actionType: undefined
})

export const userMeAtom = atom<UserMeAtom>({ data: {} })
